import React from 'react';

import { padding } from '@lumapps/classnames';
import { mdiThumbUp } from '@lumapps/lumx/icons';
import { ColorPalette, FlexBox, Icon, Size, Text, Theme } from '@lumapps/lumx/react';

import type { MultiReactionButtonProps } from '../MultiReactionButton';

export const PublicMultiReaction: React.FC<MultiReactionButtonProps> = ({ theme, reactionCounts }) => {
    return (
        <FlexBox orientation="horizontal" hAlign="center" gap="tiny" className={padding('all', 'regular')}>
            <Icon theme={theme} icon={mdiThumbUp} size={Size.xs} />
            <Text as="span" typography="body1" color={theme === Theme.dark ? ColorPalette.light : ColorPalette.dark}>
                {reactionCounts.total}
            </Text>
        </FlexBox>
    );
};
